<div class="grid-container">
    <div class="">
        <h1 class="sansserif">คลังความรู้</h1>
    </div>
    <ul>
        <li *ngFor="let c of content">
            <a href="{{linkPath}}/{{c.path}}" target="_blank" rel="noopener noreferrer">{{c.title}}</a>
        </li>
    </ul>
</div>